import { render, staticRenderFns } from "./results.vue?vue&type=template&id=d32918de&scoped=true&"
import script from "./results.js?vue&type=script&lang=js&"
export * from "./results.js?vue&type=script&lang=js&"
import style0 from "./results.vue?vue&type=style&index=0&id=d32918de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32918de",
  null
  
)

export default component.exports